// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__1Vve3","load6":"Spinner_load6__21Icc","round":"Spinner_round__eva6H"};